import { useMemo } from 'react';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

interface ITooltipArrowProps {
    color: COLORS,
    direction?: 'left' | 'right' | 'top' | 'bottom',
}

/**
 * Вынесено отдельным компонентом (вне ui-react/svg/icons) поскольку
 * не находится в дизайн системе и не поддерживает цветовую схему `TSvgTypes`
 *
 * TODO согласовать с дизайнерами данный компонент как иконку,
 * либо заменить на существующую из дизайн системы
 */
export const TooltipArrow = ({ color, direction = 'top' }: ITooltipArrowProps): JSX.Element => {
    const transform = useMemo(() => {
        switch (direction) {
            case 'bottom':
                return 'rotate(0deg)';
            case 'right':
                return 'rotate(-90deg) translateY(2px)';
            case 'left':
                return 'rotate(90deg) translateY(2px)';
            case 'top':
                return 'rotate(180deg)';
        }
    }, [direction]);

    return (
        <svg
            width='10'
            height='7'
            viewBox='0 0 10 7'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            style={{ transform }}
        >
            <path
                d='M0 7L4.18627 1.13923C4.58509 0.580878 5.41491 0.580878 5.81373 1.13923L10 7H0Z'
                fill={color}
            />
        </svg>
    );
};
